import { render, staticRenderFns } from "./approval-icon-new.vue?vue&type=template&id=59664a86&scoped=true"
import script from "./approval-icon-new.vue?vue&type=script&lang=js"
export * from "./approval-icon-new.vue?vue&type=script&lang=js"
import style0 from "./approval-icon-new.vue?vue&type=style&index=0&id=59664a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59664a86",
  null
  
)

export default component.exports